import { ReduxStateHandler } from '../ReduxStateHandler';

export const CheckoutTimerStateHandler = new ReduxStateHandler({
  actionName: 'data/UPDATE_CHECKOUT_TIMER',
  statePath: 'checkoutTimerData',
});
